import type { Components } from '@mui/material/styles';

export default function MuiAccordionActions(): Components['MuiAccordionActions'] {
  return {};
}
